// removed by extract-text-webpack-plugin
module.exports = {"row":"_pgUfG","container":"_hNuw3","content":"_LJpWw","detail":"_PaGAO","title":"_FQoax","description":"_3VEUy"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Law/Law.scss
// module id = 1653
// module chunks = 27